import { IdentityApi } from '@/api';
import { apiConfiguration } from '@/api/config';

export const identityApi = new IdentityApi(apiConfiguration);
